import { render, staticRenderFns } from "./OrderMailTagExportPage.vue?vue&type=template&id=6be58b74&scoped=true"
import script from "./OrderMailTagExportPage.vue?vue&type=script&lang=js"
export * from "./OrderMailTagExportPage.vue?vue&type=script&lang=js"
import style0 from "./OrderMailTagExportPage.vue?vue&type=style&index=0&id=6be58b74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be58b74",
  null
  
)

export default component.exports